import React, { useEffect } from 'react'
import AdminKarayollariContainer from '../adminContainers/AdminKarayollariContainer'
import { useSelector } from 'react-redux';
import Button from '../shared/button/Btn';
import styled from 'styled-components';
import { showModal } from '../../features/modal/modalSlice';
import { useDispatch } from 'react-redux';
import { getAllInspectionStationLocation } from '../../features/admin3/admin3Slice';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
    .btn-container{
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .titles {
        width: 100%;
        display: grid;
        grid-template-columns:repeat(8, 1fr);
        gap: 15px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
`

const titles = ["Ekleme Tarihi","İstasyon Adı", "İl", "İlçe", "Lokasyon", "Yön", "Lat", "Lng"];

const InspectionStationLocation = () => {
    const {adminInspectionStationLocationList} = useSelector((state) => state.admin3);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllInspectionStationLocation())
      }, [])

    return (
        <Container>
            <div className="btn-container">
                <Button color={"#E85546"}  background={"#fff"} width="150px" radius={"10px"} handleClick={() => dispatch(showModal("addKarayollariIstasyon"))}>İstasyon Ekle</Button>
            </div>

            <div className="titles">
                {titles.map((item) => (
                <p>{item}</p>
                ))}
            </div>

            {adminInspectionStationLocationList.map((item) => (
                <AdminKarayollariContainer data={item} />
            ))}
        </Container>
    )
}

export default InspectionStationLocation